package top.wcpe.allincore.layout.engine

import kotlin.jvm.JvmStatic

/**
 * 表示可用空间，对应 CSS 布局中的 `definite/min-content/max-content` 三态。
 */
class AvailableSpace private constructor(
    private val type: Type,
    private val width: Float,
    private val height: Float
) {

    /** 可用空间类型枚举。 */
    enum class Type {
        DEFINITE,
        MIN_CONTENT,
        MAX_CONTENT
    }

    fun type(): Type = type

    /** 当 [type] 为 [Type.DEFINITE] 时有效，否则返回 0。 */
    fun width(): Float = width

    /** 当 [type] 为 [Type.DEFINITE] 时有效，否则返回 0。 */
    fun height(): Float = height

    companion object {

        private val MIN = AvailableSpace(Type.MIN_CONTENT, 0f, 0f)
        private val MAX = AvailableSpace(Type.MAX_CONTENT, 0f, 0f)

        /** 提供确定的宽高约束。 */
        @JvmStatic
        fun definite(width: Float, height: Float): AvailableSpace {
            return AvailableSpace(Type.DEFINITE, width, height)
        }

        /** 取一个最小内容尺寸的可用空间。 */
        @JvmStatic
        fun minContent(): AvailableSpace {
            return MIN
        }

        /** 取一个最大内容尺寸的可用空间。 */
        @JvmStatic
        fun maxContent(): AvailableSpace {
            return MAX
        }
    }
}
